import React, { ReactNode, useRef } from 'react';
import { IGatsbyImageData } from 'gatsby-plugin-image';

type BackgroundImageProps = {
  className?: string;
  children?: ReactNode;
  image: IGatsbyImageData;
};

const resolveImageSrc = (data: IGatsbyImageData) => {
  let src = '';
  if (data && data.images) {
    if (
      data.images.sources &&
      Array.isArray(data.images.sources) &&
      data.images.sources.length > 0
    ) {
      const source = data.images.sources[0];
      const srcSetRegex = /([^"'\s,]+)\s*\s+\d+[wx](?:,\s*)?/gm;
      const allSources = [...source.srcSet.matchAll(srcSetRegex)];
      src = allSources[allSources.length - 1][1];
    } else if (data.images.fallback) {
      src = data.images.fallback.src;
    }
  }
  return src;
};

const BackgroundImage = ({
  className,
  children,
  image,
}: BackgroundImageProps) => {
  const srcRef = useRef(resolveImageSrc(image));
  const style = {
    '--background-image-var': `url(${srcRef.current})`,
  } as React.CSSProperties;

  return (
    <>
      <section style={style} className={`background-image ${className}`}>
        {children}
      </section>
    </>
  );
};

export default BackgroundImage;
